import { Blockquote, Button, Card, Center, Group, HoverCard, List, Space, Stack, Text } from "@mantine/core";
import Head from "next/head";
import { MenuId } from "../components/Header";
import Layout from "../components/Layout";
import styles from "./subscription.module.scss"
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBadgeCheck, faBan, faCheck } from '@fortawesome/pro-solid-svg-icons'
import Link from "next/link";
import { Price } from "../components/Localization";
import { ReactNode, JSX} from "react";
import EmailSignupBanner from "../components/EmailSignupBanner";
import { ShoppingCartItemType, SubscriberLevel, SubscriptionShoppingCartItem } from "../lib/definitions";
import { useRawUmberContext } from "../lib/rawumberprovider";
import { useRouter } from "next/router";
import { GetServerSideProps } from "next";
import { getGBPPriceForSubscription } from "../lib/utils";


/*
type CardData =
{
    title: string,
    features: string []
}
*/

type CardData =
{
    title: string,
    features: JSX.Element,
    priceGBP: number,
    subscriberLevel: SubscriberLevel
}


export default function SubscriptionPage({data} : {data: {gift : boolean}})
{

    
    /*
    let imageData : CardData =
    {
        title: "Image subscription",
        features: ["Searchable image database",
                "Over 1,500 images",
                "Categorised by pose, gender and more"
                 ]
    };

    let standardData : CardData =
    {
        title: "Standard subscription",
        features: ["Live sessions twice a week",
                "Guided portrait drawing every Sunday",
                "Figure drawing every Wedesday",
                "Top guidance from professional artists",
                "Searchable database of over 325 videos",
                "Categorised by pose, gender and more"
                 ]

    };

    let goldData : CardData =
    {
        title: "Gold subscription",
        features: ["Live sessions twice a week",
                "Guided portrait drawing every Sunday",
                "Figure drawing every Wedesday",
                "Frequent bonus sessions",
                "Top guidance from professional artists",
                "Searchable database of over 400 past sessions",
                "Categorised by pose, gender and more",
                "Searchable image database",
                "Over 1,500 images",
                "Categorised by pose, gender and more"

                 ]
    };*/

    let liveSessionInformation=<HoverLink text="Live sessions twice a week" link="/upcoming-online-sessions">Click <Link href='/upcoming-online-sessions'>here</Link> to see the upcoming sessions, or use the form at the bottom of this page to receive <b>SEVEN</b> free example videos</HoverLink>
    let imageSearchInformation=<HoverLink text="Searchable image database" link="/image-search">Click <Link href='/image-search'>here</Link> to try out the image search</HoverLink>
    let videoSearchInformation=<HoverLink text="Searchable video database" link="/new-video-search">Click <Link href='/new-video-search'>here</Link> to see the video search</HoverLink>
    let bonusVideoInformation=<HoverLink text="Regular bonus videos">Use the form at the bottom of this page to receive <b>SEVEN</b> free example videos</HoverLink>
    let threeDInformation=<HoverLink text="3D library" link="/3d-models">Click <Link href='/3d-models'>here</Link> to try the 3D library</HoverLink>
    
    let imageData : CardData =
    {
        title: "Image subscription",
        features: <><List.Item>{imageSearchInformation}</List.Item>
                <List withPadding icon={<FontAwesomeIcon icon={faCheck} color="blue"/>}>
                <List.Item>Over 3,000 images</List.Item>
                <List.Item>Categorised by pose, gender and more</List.Item>

                </List>
                <List.Item>Cancel at any time</List.Item>
                </>,
        priceGBP: getGBPPriceForSubscription(SubscriberLevel.image),
        subscriberLevel: SubscriberLevel.image
    };
/*
    let standardData : CardData =
    {
        title: "Standard subscription",
        features: <><List.Item>{liveSessionInformation}</List.Item>
                <List withPadding icon={<FontAwesomeIcon icon={faCheck} color="blue"/>}>
                    <List.Item>Guided portrait drawing every Sunday</List.Item>
                    <List.Item>Figure drawing every Wednesday</List.Item>
                    <List.Item>Top guidance from professional artists</List.Item>
                </List>
                <List.Item>{videoSearchInformation}</List.Item>
                <List withPadding icon={<FontAwesomeIcon icon={faCheck} color="blue"/>}>
                <List.Item>Over 750 figure and portrait videos</List.Item>
                <List.Item>Categorised by pose, gender and more</List.Item>
                </List>
                <List.Item icon={<FontAwesomeIcon icon={faBan} color="red"/>}>{imageSearchInformation} NOT included</List.Item>
                <List.Item icon={<FontAwesomeIcon icon={faBan} color="red"/>}>Extra videos NOT included</List.Item>

                <List.Item>Cancel at any time</List.Item>
                </>,
                priceGBP:getGBPPriceForSubscription(SubscriberLevel.standard),
                subscriberLevel: SubscriberLevel.standard
    };*/

    let goldData : CardData =
    {
        title: "Gold subscription",

        features: <><List.Item>{liveSessionInformation}</List.Item>
                <List withPadding icon={<FontAwesomeIcon icon={faCheck} color="blue"/>}>
                    <List.Item>Guided portrait drawing every Sunday</List.Item>
                    <List.Item>Figure drawing every Wednesday</List.Item>
                    <List.Item>Top guidance from professional artists</List.Item>
                </List>
                <List.Item>{bonusVideoInformation}</List.Item>
                <List.Item>{videoSearchInformation}</List.Item>
                <List withPadding icon={<FontAwesomeIcon icon={faCheck} color="blue"/>}>
                <List.Item>Over 750 figure and portrait videos</List.Item>
                <List.Item>Over 100 additional videos</List.Item>
                <List.Item>Categorised by pose, gender and more</List.Item>
                </List>
                <List.Item>{imageSearchInformation}</List.Item>
                <List withPadding icon={<FontAwesomeIcon icon={faCheck} color="blue"/>}>
                <List.Item>Over 3,000 images</List.Item>
                <List.Item>Categorised by pose, gender and more</List.Item>
                </List>
                <List.Item>{threeDInformation}</List.Item>
                <List.Item>Cancel at any time</List.Item>
                </>,
                priceGBP: getGBPPriceForSubscription(SubscriberLevel.gold),
                subscriberLevel: SubscriberLevel.gold           

    }
    return <>
     <Layout menuId={MenuId.subscribe}>
                <Head>
                    <title>Raw Umber Subscription</title>
                    <meta name="description" content="Online art tutorials featuring artists from around the world. Plus a large library of videos and image references."></meta>
                </Head>

                <div className={styles.heroContainer}>
                    <div className={styles.heroContent}>
                
                <h1>Raw Umber Subscription</h1>
                <Text>We offer 2 levels of subscription. Choose our <b>image subscription</b> if you just want our image library, or the <b>gold subscription</b> if you want to access the images, twice-weekly live sessions and our extensive video library.</Text>
                <Space h='lg'/>
    <Blockquote color="yellow" cite="- Mike Sykes">
    <Text size="md">The perfect, challenging stimulus to develop and improve my own style of portrait and figure drawing [...] a super set of reference materials and videos to go back to.</Text>
    </Blockquote>
    <Space h="lg" />
    </div>


    </div>

    <Group justify="center" align="stretch" >
    <SubscriptionCard data={imageData} color="silver" gift={data.gift}/>
    {/* <SubscriptionCard data={standardData} color="blue"  gift={data.gift}/>*/}

    <SubscriptionCard data={goldData} color='#ccb668' gift={data.gift} />

    </Group>

    <Space h="lg" />
                <EmailSignupBanner/>
    </Layout>

    </>

}

/*
function MoreInformation(props: {children:ReactNode} & {link?:string})
{
    return(
        <HoverCard width={280} shadow="md">
            {props.link &&
    <HoverCard.Target>
     <Link href={props.link}><FontAwesomeIcon icon={faCircleInfo} color="blue"/></Link>
    </HoverCard.Target>
}
{!props.link &&
    <HoverCard.Target>
     <FontAwesomeIcon icon={faCircleInfo} color="blue"/>
    </HoverCard.Target>
}
    <HoverCard.Dropdown>
      <Text size="sm">
        {props.children}
      </Text>
    </HoverCard.Dropdown>
  </HoverCard>
    )
}*/

function HoverLink(props: {children:ReactNode, text:string} & {link?:string})
{
    return(
        <HoverCard width={280} shadow="md">
            {props.link &&
    <HoverCard.Target>
     <Link href={props.link} className={styles.hoverLink}>
        {props.text}
        </Link>
    </HoverCard.Target>
}
{!props.link &&
    <HoverCard.Target>
        <div className={styles.hoverText}>{props.text}</div>
    </HoverCard.Target>
}
    <HoverCard.Dropdown>
      <Text size="sm">
        {props.children}
      </Text>
    </HoverCard.Dropdown>
  </HoverCard>
    )
}


function SubscriptionCard(props: {data: CardData, color:string, gift:boolean})
{

    const {setShoppingCartItem} = useRawUmberContext();

    const { localizationInformation} = useRawUmberContext();
    const router = useRouter();

    function pCheckout(level: SubscriberLevel, type:ShoppingCartItemType)
    {
        let cart: SubscriptionShoppingCartItem = {
            emailAddress: "",
            quantity: 1,
            firstName: "",
            lastName:"",
            itemType: type,
            countryCode: "" + localizationInformation?.CountryCode,
            stateCode:"",
            optIn:true,
            phoneNumber: "",
            
            data: 
            {
                level:level,
                userName:''
            }
          };
      
          setShoppingCartItem(cart);

          let url = "/checkout-subscription" + (type==ShoppingCartItemType.gift?"?gift=1":"")
          router.push(url);
    }
    function checkout(level : SubscriberLevel)
    {
        pCheckout(level, ShoppingCartItemType.subscription);      
    }

    function checkoutGift(level : SubscriberLevel)
    {
        
        pCheckout(level, ShoppingCartItemType.gift);      
    }


    return(
    <Card shadow="sm" p="lg" radius="md" withBorder>
        <Card.Section className={styles.cardHeader} style={{backgroundColor:props.color}}>
<Text size="lg">{props.data.title}</Text>
</Card.Section>
<div className={styles.cardContent}>
<List icon={
        
          <FontAwesomeIcon icon={faBadgeCheck} color="teal"/>
    
      }>
    {
        props.data.features
    }
</List>

<div className={styles.priceBox}><span className={styles.priceValue}><Price gbp={props.data.priceGBP}/></span> / month</div>
<Space h="lg"/>
<Stack>
{!props.gift && <Button onClick={()=>checkout(props.data.subscriberLevel)}>Subscribe now!</Button>}

<Button color='grey' onClick={()=>checkoutGift(props.data.subscriberLevel)}>Buy as a gift</Button>

</Stack>
<div className={styles.blankRow}></div>


</div>
    </Card>);
    
}

export const getServerSideProps : GetServerSideProps = async (context)=>
{
 
    const gift = context.query?.gift;
    return {
        props: {
          data: 
          { 
              gift: !!gift
          }
        }
    }
  
  }
